import { EarningsPeriod } from '@api';
import { isBefore, subMonths } from 'date-fns';

const quarterDateBounds: Record<string, readonly [string, string]> = {
  Q1: ['01-01', '03-31'],
  Q2: ['04-01', '06-30'],
  Q3: ['07-01', '09-30'],
  Q4: ['10-01', '12-31'],
};

export const getReportingPeriodLabel = ({
  fiscal_period,
  fiscal_year,
}: Pick<EarningsPeriod, 'fiscal_period' | 'fiscal_year'>) =>
  `${fiscal_period} ${fiscal_year}`;

export const getReportingPeriodTimeframe = ({
  fiscal_period,
  fiscal_year,
}: Pick<EarningsPeriod, 'fiscal_period' | 'fiscal_year'>) => {
  const bounds = quarterDateBounds[fiscal_period];
  if (!bounds) {
    return undefined;
  }

  return {
    startDate: `${fiscal_year}-${bounds[0]}`,
    endDate: `${fiscal_year}-${bounds[1]}`,
  };
};

/**
 * `reportingPeriods` is sorted from soonest/most-recent to oldest, so the
 * first item is the upcoming (or just-passed) report. Defaults to that
 * period once its reporting date is a month or less away, otherwise falls
 * back to the most recently reported quarter.
 */
export const getDefaultActiveReportingPeriod = (
  reportingPeriods: EarningsPeriod[]
): EarningsPeriod => {
  const [nextReportingPeriod] = reportingPeriods;

  const isWithinAMonthOfNextReport =
    !!nextReportingPeriod &&
    isBefore(
      subMonths(new Date(nextReportingPeriod.reporting_date), 1),
      new Date()
    );

  if (isWithinAMonthOfNextReport) {
    return nextReportingPeriod;
  }

  const lastReportedPeriod = reportingPeriods.find(period => period.reported);

  return lastReportedPeriod ?? nextReportingPeriod;
};
